import React from "react";
import SearchIcon from "../../assets/svgs/search-icon.svg";

import "./style.scss";

const SearchBar = ({ searchTerm, setSearchTerm }) => {
  const handleChange = (e) => setSearchTerm(e.target.value);
  const onClearClick = () => setSearchTerm("");

  return (
    <div id="search-bar" className="input-group">
      <input
        type="text"
        placeholder="Search..."
        value={searchTerm}
        onChange={handleChange}
      />
      {searchTerm === "" && <SearchIcon className="search-icon" />}
      {searchTerm && (
        <i className="clear-icon fa fa-times" onClick={onClearClick}></i>
      )}
    </div>
  );
};

export default SearchBar;
